import React, { Component } from 'react';
import Header from '../header/newheader';
import ResearchDivision from './researchDivision';
import ResearchCluster from './researchCluster';
import Faculty from '../faculty/faculty';
import Footer from '../footer/footerbkp';


class Research extends Component {
  constructor(props) {
    super(props);
    console.log(props, "123")

    this.state = {
      type: props.match.params.type
    }

  }
  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    // window.location.href = '/'

  }


  refreshexp() {
    let s = new Date();
    s.setSeconds(s.getSeconds() + 1800);
    localStorage.setItem('expiryref', s)
  }


  checkexpiry() {
    if (localStorage.getItem('expiryref')) {
      let expref = Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if (s > expref) {
        this.signout()
      }
      else {
        this.refreshexp()
      }

    }
    else {
      this.signout()
    }
  }




  componentWillReceiveProps(nextProps) {
    if (localStorage.getItem('token'))
      this.checkexpiry()
    this.setState({
      type: nextProps.match.params.type
    })
  }

  settype(type) {
    this.setState({
      type: type
    })
    this.props.history.push('/research/' + type)

  }

  render() {
    return (
      <div>
        <Header />
        {/* <div className="container">
                    <div className="tabsection">
                        <button style={{backgroundColor:this.state.type==='division'?'#165E84':''}} onClick={()=>this.settype('division')}>Research Division</button>
                        <button style={{backgroundColor:this.state.type==='cluster'?'#165E84':''}} onClick={()=>this.settype('cluster')}>Research Cluster</button>
                        <button style={{backgroundColor:this.state.type==='faculty'?'#165E84':''}} onClick={()=>this.settype('faculty')}>Faculty</button>
                    </div>
                </div> */}
        {/* REseARCH DIVISION */}
        <div style={{ display: this.state.type === 'division' ? '' : 'none' }}>
          <ResearchDivision />
        </div>
        {/* CLUSTER */}
        <div style={{ display: this.state.type === 'cluster' ? '' : 'none' }}>
          <ResearchCluster props={this.state.tab1} />
        </div>
        <div style={{ display: this.state.type === 'centers' ? '' : 'none' }}>
          <ResearchCluster />
        </div>
        <div className={this.state.type !== 'faculty' ? "filterfooter nobottom" : "filterfooter"}>
          <Footer />
        </div>
      </div>
    )
  }
}

export default Research;
